<div class="legal-container">
  <div class="legal-card">
    <div class="legal-header">
      <h1>TERMS OF SERVICE</h1>
    </div>

    <div class="legal-content text-content">
      {{ termsContent }}
    </div>

    <div class="back-link">
      <a routerLink="/home">Back to Portal</a>
    </div>
  </div>
</div>
